import { render, staticRenderFns } from "./CallingPlayer.vue?vue&type=template&id=4e3ccf51&scoped=true"
import script from "./CallingPlayer.vue?vue&type=script&lang=js"
export * from "./CallingPlayer.vue?vue&type=script&lang=js"
import style0 from "./CallingPlayer.vue?vue&type=style&index=0&id=4e3ccf51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ccf51",
  null
  
)

export default component.exports